import React from 'react';
import Clearfix from 'components/elements/clearfix';
import { Row, Col } from 'reactstrap';
import { PanelStack } from '@blueprintjs/core';
import LookuplistPanelStack from './1_LookuplistPanelStack';

export default class DanhMucHoaChat extends React.Component {
  initialPanel = {
    component: LookuplistPanelStack,
    props: {
      panelNumber: 1,
    },
    title: 'Danh mục',
  };

  state = {
    isLoading: true,
    currentPanelStack: [this.initialPanel],
  };

  render() {
    return (
      <div style={{ width: '100%' }}>
        <Clearfix height={8} />
        <Clearfix height={8} />
        <Row>
          <Col xs={12}>
            <PanelStack
              className='bp3-panel-stack-custom'
              initialPanel={this.state.currentPanelStack[0]}
              //   onOpen={this.addToPanelStack}
              //   onClose={this.removeFromPanelStack}
            />
          </Col>
        </Row>
        <Clearfix height={16} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ManagementContainer/danh-muc-hoa-chat/index.js